import * as Amplitude from "@amplitude/analytics-browser"

/**
 * User clicked a button.
 */
export function buttonClicked(buttonText?: string) {
  return Amplitude.track("button_clicked", {
    button_text: buttonText,
  })
}

/**
 * User has seen an alert.
 */
export function alertImpression(alertTitle?: string) {
  return Amplitude.track("alert_impression", {
    alert_title: alertTitle,
  })
}

/**
 * User dismissed a an announcement banner.
 */
export function bannerDismissed(bannerTitle?: string) {
  return Amplitude.track("banner_dismissed", {
    banner_title: bannerTitle,
  })
}
